// JointHolder/Review/index.js
import React from 'react';

function Review() {
    return <div>Review Information</div>;
}

export default Review;
